import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import api from "../api/api";
import "./form.css";
import BackButton from "../components/BackButton";
import usePagination from "../utils/usePagination";
import Table from "../components/table";
 
const WarehouseAddRequests = () => {
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(responses, 5);
 
  useEffect(() => {
    const fetchResponses = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/warehouse/add-wh-requests`);
        setResponses(response.data.requests || []);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch warehouse add requests");
        setResponses([]);
      } finally {
        setLoading(false);
      }
    };
 
    fetchResponses();
  }, []);
             
  const columns = [
    { label: "Warehouse Name", accessor: "warehouse_name" },
    {
      label: "Owner Name",
      accessor: "owner_name",
    },
    { label: "Address", accessor: "location_city" || "address" },
    { label: "Base Rate", accessor: "base_rate" },
    {
      label: "Action",
      render: (item) => (
        <Link to={`/view-warehouse-details/${item.id}`}>
          <VisibilityIcon />
        </Link>
      ),
    },
  ];
 
  return (
    <>
      <BackButton />
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No New Warehouses Add Requests Found"
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />
    </>
  );
};
 
export default WarehouseAddRequests;